import React, { useEffect, useRef, useState } from "react"
import { NavLink } from "react-router-dom"
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'

import { TOGGLE_LEFT_MENU } from 'store/layout/actions'
//Import Scrollbar
import { Nav } from 'react-bootstrap'
import { exportMenu } from './menu'

import { brandName } from 'helpers/brand';
import { SET_FILTER_DATA } from "store/filterData/actions";
import { GET, httpOk } from 'helpers/api'

function SidebarContent() {
	const brandTitle = brandName()
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const ref = useRef();

	const reduxAccount = useSelector(state => state.account)
	const layoutSelector = useSelector(state => state.layout)
	const reduxFilterData = useSelector(state => state.filterData)

	const [menu, setMenu] = useState([])
	const [activeItem, setActiveItem] = useState({
		children: []
	})
	// Javobsiz shikoyatlar soni — menyudagi qizil raqam
	const [newComplaints, setNewComplaints] = useState(0)

	/* Yengil so'rov (faqat son). Har 2 daqiqada yangilanadi — shikoyat kelganini
	   bo'limni ochmasdan bilish uchun. Bo'lim tarifga kirmasa so'rov ham yuborilmaydi. */
	useEffect(() => {
		const hasSection = (reduxAccount.permissions || []).some(p => p.name === 'sec.complaints')
		if (!hasSection) return

		let stop = false
		async function load() {
			const res = await GET('/complaints-new-count', {}, { loader: false })
			if (!stop && httpOk(res)) setNewComplaints(res.data?.count ?? 0)
		}
		load()
		const timer = setInterval(load, 120000)
		return () => { stop = true; clearInterval(timer) }
	}, [reduxAccount.permissions])

	function checkMenuAccess() {
		// Tarif cheklovi HAMMA rolga qo'llanadi — EGA ham. Bo'limlar biznes tarifiga bog'liq
		// (avval ROLE_OWNER filtrdan chetlab o'tar edi, shunda tarif ma'nosiz bo'lardi).
		const filtered = filterMenuByPermissions([...exportMenu], reduxAccount.permissions || [])
		setMenu(filtered)
		if (filtered.length > 0) setActiveItem(filtered[0])
	}

	function filterMenuByPermissions(passedMenu, permissions) {
		const permissionNames = (permissions || []).map(p => p.name);

		// Ruxsatlar hali kelmagan bo'lsa (eski saqlangan holat, yangilanish yo'lda) menyuni
		// bo'm-bo'sh qilib qo'ymaymiz — haqiqiy himoya baribir backendда (SectionAccess).
		if (permissionNames.length === 0) return passedMenu;

		return passedMenu
			.map(menuItem => {
				if (!menuItem.children) return menuItem;
				// 1) Ruxsat yo'q bandlarni olib tashlash (permission belgilanmagani doim ko'rinadi)
				let children = menuItem.children.filter(child => {
					return !child.permission || permissionNames.includes(child.permission);
				});
				// 2) Ortda qolgan yolg'iz sarlavhani tozalash (ostida band qolmagan bo'lsa)
				children = children.filter((child, i, arr) => {
					if (!child.title) return true;
					const next = arr[i + 1];
					return next && !next.title;
				});
				return { ...menuItem, children };
			})
			// 3) Umuman bandi qolmagan guruhni ko'rsatmaslik
			.filter(m => !m.children || m.children.some(c => !c.title));
	}

	function setActiveChild(index) {
		dispatch(TOGGLE_LEFT_MENU(true))
		var menuCopy = [...menu]

		for (let i = 0; i < menuCopy.length; i++) {
			for (let j = 0; j < menuCopy[i]['children'].length; j++) {
				menuCopy[i]['children'][j]['active'] = false;
			}
		}

		const i = menuCopy.findIndex(x => x.icon === activeItem.icon)
		menuCopy[i]['children'][index]['active'] = !menuCopy[i]['children'][index]['active']
		setActiveItem(menuCopy[i])

		if (reduxFilterData?.url) {
			dispatch(SET_FILTER_DATA({}))
		}
	}

	function setActiveTab(item) {
		setActiveItem(item)
		dispatch(TOGGLE_LEFT_MENU(true))
	}

	useEffect(() => {
		checkMenuAccess()
		// Ruxsatlar yangilanganda (tarif o'zgarsa) menyu qayta filtrlanadi
	}, [reduxAccount.permissions]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div ref={ref} className={`sidebar-menu-scroll ${layoutSelector.showleftMenu ? 'box-shadow-none' : ''}`}>
				<Nav className="nav-mini" activeKey={activeItem.icon}>
					{menu.map((item, index) => (
						<Nav.Item onClick={() => setActiveTab(item)} key={index}>
							<Nav.Link eventKey={item.icon}>
								<span className="fw-bold"><i className={item.icon}></i></span>
							</Nav.Link>
						</Nav.Item>
					))}
				</Nav>
				<div className="app-version">
					{t('version')}
					<br />
					<div className="text-center">
						{process.env.REACT_APP_VERSION}
					</div>
				</div>
			</div>

			<div className={"second-sidebar" + (layoutSelector.showleftMenu ? '' : ' d-none')}>
				{/* ⚠️ MAHSULOT LOGOTIPI (Tameer) — 2026-09-10, yuqoridagi izohga qarang.
				    Korxona NOMI ostida kichik matn bo'lib qoladi: usta qaysi
				    korxonada ishlayotganini bilsin, lekin brend Tameer bo'lsin. */}
				<div className="second-sidebar-logo">
					<img src="/tameer-logo.png" alt="Tameer" style={{ maxWidth: 140, maxHeight: 32 }} />
					{brandTitle &&
						<div className="text-muted" style={{ fontSize: 11, marginTop: 2 }}>{brandTitle}</div>}
				</div>

				<div id="sidebar-menu">
					<ul className="metismenu list-unstyled" id="side-menu">
						{activeItem.children.map((item, index) => (
							<li className={item.active ? "mm-active" : ""} key={index}>
								{item.title == null ?
									<NavLink to={item.url}
										onClick={() => setActiveChild(index)} className={"waves-effect d-flex " + (item.active ? "active" : "")}>
										<i className={item.icon}></i>
										<div className="vertical-menu-div">{t(item.i18n)}</div>
										{/* Javobsiz shikoyatlar soni — bo'limni ochmasdan ko'rinadi */}
										{(item.url === '/complaints' && newComplaints > 0) &&
											<span className="badge bg-danger ms-auto align-self-center">
												{newComplaints}
											</span>
										}
									</NavLink>
									:
									<div className="second-sidebar-title">
										<div>{t(item.i18n)}</div>
									</div>
								}
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	)
}

export default SidebarContent